import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { ButtonInputModel } from 'src/app/presentation/general/button/button.component';
import { Subscription } from 'rxjs';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { ActivityLevels } from 'src/app/core/model/activity-level-model';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import { ActivityLevelService } from 'src/app/data/repository/generate-repository/activity-level.service';
import { LoadingShared } from 'src/app/presentation/general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';

@Component({
  selector: 'app-activity-level',
  templateUrl: './activity-level.component.html',
  styleUrls: ['./activity-level.component.scss'],
})
export class ActivityLevelComponent implements OnInit, OnDestroy {
  @Input() isDetail = false;
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;
  @Input() needCalculate: boolean;

  configButtons: ButtonInputModel[] = new Array();

  subscription: Subscription;

  constructor(
    private submitButtonShared: SubmitButtonShared,
    private generateShared: GenerateShared,
    private generateService: GenerateService,
    private activityLevelService: ActivityLevelService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService
  ) {
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (this.isDetail) {
          if (clicked && this.pageNumber === this.currentPageNumber) {
            this.generateShared.activityLevel =
              this.generateShared.activityLevelTemp;
            this.generateShared.closeOverviewDetailAndChangeDifficulty();
          }
        } else {
          if (clicked && this.pageNumber === this.currentPageNumber) {
            if (this.needCalculate) {
              this.loadingShared.showLoading();
              this.generateService
                .calculate(
                  this.generateShared.weight,
                  this.generateShared.goal,
                  this.activityLevelService.getActivityLevelEngNameById(
                    this.generateShared.activityLevel
                  ),
                  this.generateShared.goal === 'pregnancy'
                    ? this.generateShared.specialTypeStartDate.getTime()
                    : null,
                  this.generateShared.goal === 'breastfeeding'
                    ? this.generateShared.specialTypeStartDate.getTime()
                    : null
                )
                .then((res) => {
                  if (res.isSuccess()) {
                    if (
                      this.generateShared.goal === 'weightLoss' ||
                      this.generateShared.goal === 'weightGain'
                    ) {
                      let showPopup = true;
                      this.generateShared.getCalories().forEach((calorie) => {
                        if (calorie.suitable) {
                          showPopup = false;
                        }
                      });
                      if (showPopup) {
                        this.generateShared.showPopup();
                      } else {
                        this.generateShared.nextPage();
                      }
                    } else {
                      this.generateShared.nextPage();
                    }
                  } else {
                    if (res.getData() && res.getData().getMessage()) {
                      this.snackBarService.showSnackBar(
                        res.getData().getMessage()
                      );
                    } else {
                      this.snackBarService.showSnackBar(
                        'خطا در برقراری ارتباط با سرور!'
                      );
                    }
                  }
                  this.loadingShared.hideLoading();
                });
              // console.log('activity', this.generateShared.activityLevel)
            } else {
              this.generateShared.nextPage();
            }
          }
        }
      }
    );
  }

  ngOnInit() {
    if (this.isDetail) {
      ActivityLevels.forEach((activity) => {
        this.configButtons.push({
          isOneLine: false,
          title: activity.getName(),
          imgUrl: activity.getImg(),
          description: activity.getDescription(),
          id: activity.getID(),
          type: 'activity',
          isSelected:
            this.generateShared.activityLevel === activity.getID()
              ? true
              : false,
        });
      });
    } else {
      ActivityLevels.forEach((activity) => {
        this.configButtons.push({
          isOneLine: false,
          title: activity.getName(),
          imgUrl: activity.getImg(),
          description: activity.getDescription(),
          id: activity.getID(),
          type: 'activity',
        });
      });
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
